// WHAT: Aggregated View Page Component
// WHY:  Simple page wrapper that renders AggregatedViewTab
// DOMAIN: Productivity → TimeTracQ
// DEPENDENCIES: AggregatedViewTab component
// RISKS:
//   - NOTE: This is a thin wrapper with no additional logic

import { AggregatedViewTab } from "../../screen/tabs/AggregatedViewTab";

/**
 * WHAT:
 *   Page component that renders the Aggregated View tab.
 *
 * WHY:
 *   Provides routing entry point for aggregated time tracking view.
 *
 * BEHAVIOR:
 *   - Simply renders AggregatedViewTab component
 *   - No additional logic or state management
 *
 * RISKS:
 *   - NOTE: This is a thin wrapper - consider removing if not needed for routing
 *
 * @returns {JSX.Element} The aggregated view page component
 *
 */
export const AggregatedViewPage = () => {
  return <AggregatedViewTab />;
};
